import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './native-overrides.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initNative } from './native/init';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

initNative();
